import React, { useState, useEffect  } from 'react'
// import { useSelector, useDispatch } from "react-redux";
import {
  Row,
  Col,
  // ListGroupItem,
  CustomInput,
  Input,
  Button,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PaymentCard from './PaymentCard'

// PaymentSubscriptionItem
const PaymentSubscriptionItem = (props) => {

  let [editPaymentMethod, setEditPaymentMethod] = useState(false);
  let [cancelingFlg, setCancelingFlg] = useState(false)

  // componentDidMount
  useEffect(() => {

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // _cancel
  let _toggleCancel = () => {

    if (cancelingFlg === true) {
      setCancelingFlg(false)
    } else {
      setCancelingFlg(true)
    }
  }

  // _cancel
  let _cancel = () => {
    setCancelingFlg(false)
    props.cancelSubscription(props.item)
  }

  // _edit
  let _toggleEdit = () => {

    if (editPaymentMethod === true) {
      setEditPaymentMethod(false)
    } else {
      setEditPaymentMethod(true)
    }
  }

  // _updatePaymentMethod
  let _updatePaymentMethod = (paymentMethodId) => {

    setEditPaymentMethod(false)

    props.updatePaymentMethod(paymentMethodId, props.item.subscription_id)
  }

  return (
    <div className="shadow2dp" style={{
      padding: 20,
      backgroundColor: '#ffffff',
      marginTop: 20,
      marginBottom: 20,
      display: props.showCanceled === false && props.item.subscription_status === "canceled" ? 'none' : 'block',
    }}>

      <Row style={{
        marginTop: 0,
        marginBottom: 0,
      }}>

        <Col md="6" xs="12" style={{
          textAlign: 'left',
          fontSize: 12,
        }}>
          <span>
            {props.item.createdAt}
          </span>
        </Col>
        <Col md="6" xs="12" style={{
          textAlign: 'right',
        }}>

          {props.item.subscription_status === "canceled" && (
            <span style={{
              backgroundColor: '#cccccc',
              borderRadius: 4,
              padding: 4,
              fontSize: 12,
            }}>
              キャンセル済み
            </span>
          )}

          {props.item.subscription_status === "active" && (
            <FontAwesomeIcon
              onClick={_toggleEdit}
              icon="edit"
              style={{
                cursor: 'pointer',
                fontSize: 16,
                marginRight: 10,
            }}/>
          )}

          {props.item.subscription_status === "payment_failed" && (
            <span style={{
              backgroundColor: '#cccccc',
              borderRadius: 4,
              padding: 4,
              fontSize: 12,
            }}>
              決済失敗
            </span>
          )}

          {props.item.subscription_status === "payment_failed" && (
            <FontAwesomeIcon
              onClick={_toggleEdit}
              icon="edit"
              style={{
                cursor: 'pointer',
                fontSize: 16,
                marginRight: 10,
            }}/>
          )}

          {props.item.subscription_status === "active" && (
            <FontAwesomeIcon
              onClick={_toggleCancel}
              icon="trash"
              style={{
                cursor: 'pointer',
                fontSize: 16,
                marginLeft: 10,
            }}/>
          )}

        </Col>
      </Row>

      {/* cancel */}
      {cancelingFlg === true && (
        <div style={{
          marginTop: 20,
          marginBottom: 20,
        }}>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12" style={{
              fontSize: 30,
              color: 'red',
            }}>
              本当にキャンセルしますか？
            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              fontSize: 16,
              textAlign: 'center',
            }}>
              <Button
                onClick={_toggleCancel}
                color="secondary"
                style={{
                  cursor: 'pointer',
                }}>
                やっぱり止めとく
              </Button>
            </Col>
            <Col md="6" xs="12" style={{
              fontSize: 16,
              textAlign: 'center',
            }}>
              <Button
                onClick={_cancel}
                color="danger"
                style={{
                  cursor: 'pointer',
                }}>
                はい、キャンセルします
              </Button>
            </Col>
          </Row>
        </div>
      )}

      <Row style={{
        marginTop: 0,
        marginBottom: 0,
      }}>
        <Col md="12" xs="12" style={{
          fontSize: 30,
        }}>

          {props.item.plan_name === "basic" && (
            <span>
              ベーシックプラン
            </span>
          )}

          {props.item.plan_name === "premium1" && (
            <span>
              プレミアムプラン
            </span>
          )}

        </Col>
      </Row>
      <Row style={{
        // borderBottomWidth: 1,
        // borderBottomStyle: 'solid',
        // borderBottomColor: '#cccccc',
      }}>
        <Col md="12" xs="12">

          {props.item.card_info && (
            <PaymentCard
              updatePaymentMethod={_updatePaymentMethod}
              setLoading={props.setLoading}
              editing={editPaymentMethod}
              item={props.item.card_info} />
          )}
        </Col>
      </Row>

      <Row>
        <Col>
          <hr style={{
            color: '#cccccc',
          }} />
        </Col>
      </Row>


      {/* charge amount  */}

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="12" xs="12">
          <span>
            今月の支払い金額(概算)
          </span>
        </Col>
      </Row>
      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="6" xs="12">
          <span style={{
            fontSize: 30,
          }}>
          {props.item.time_consumed}
          </span>
        </Col>
        <Col md="6" xs="12">
          <span style={{
            fontSize: 30,
          }}>
            {Math.ceil(props.item.charge_amount)}円
          </span>
        </Col>
      </Row>


    </div>

  )
}

export default PaymentSubscriptionItem
